import { Stage } from "./stage";
import { Mesh } from "./mesh";
import { Lights } from "./lights";

import * as THREE from "three";

export default class MVGL {
  constructor(canvas) {
    this.glReady = false;
    this.LoopTimer = [];
    this.meshLoadCount = { count: 0 };
    this.backFace = { state: false };
    this.canvas = canvas;
    this.stage = null;
    this.runRaf = true;
    this.meshList = [];
    this.lights = null;
    this.init();
    this.watchScroll();
  }

  init() {
    const meshLoadEvent = new CustomEvent("onGLReady");
    const stage = new Stage(this.canvas);
    this.stage = stage;
    stage.init();

    for (let i = 0; i < 4; i++) {
      const mesh = new Mesh(stage, i, this.meshLoadCount, meshLoadEvent);
      this.meshList.push(mesh);
      mesh.init();
    }

    const lights = new Lights(stage);
    lights.init();
    this.lights = lights;

    window.addEventListener("resize", () => {
      stage.onResize();

      this.meshList.forEach((mesh) => {
        mesh.onResize();
      });
    });

    window.addEventListener("onGLReady", () => {
      this.onGLReady();
    });
  }

  clearTimers() {
    this.LoopTimer.forEach((timer) => clearTimeout(timer));
    this.LoopTimer = [];
  }

  onGLReady() {
    this.glReady = true;
    document.body.setAttribute("data-ready", "1");
    this.setSwitch();
    this.setLoop("first");

    setTimeout(() => {
      document.body.setAttribute("data-readyout", "1");
      this.setIn();
    }, 2000);
  }

  setIn() {
    this.meshList.forEach((mesh, i) => {
      mesh.inAnim(i * 0.2);
    });
  }

  activateTurn(delay = 0.2, duration = 1) {
    //animationより先に面の確定
    const mode = this.backFace.state ? "backToFront" : "frontToBack";
    this.backFace.state = !this.backFace.state;
    document.body.setAttribute("data-mvstate", this.backFace.state ? "1" : "0");

    this.meshList.forEach((mesh, i) => {
      mesh.turn(i * delay, mode, duration);
    });
  }

  resetFaceState() {
    this.backFace.state = false;
    document.body.setAttribute("data-mvstate", "0");
  }

  setLoop(setType) {
    //console.log(`setLoop:${setType}`);
    const interval = 8000;
    let exInteval = false;

    if (setType === "reset" || setType === "first") {
      this.resetFaceState(); //初期化
    }

    if (setType === "btnChange") {
      exInteval = 16000;
    }

    const turnLoop = () => {
      document.documentElement.style.setProperty(
        "--mvInterval",
        `${interval / 1000}s`
      );
      this.activateTurn();

      if (this.runRaf) {
        this.LoopTimer.push(setTimeout(turnLoop, interval));
      }
    };

    if (exInteval) {
      document.documentElement.style.setProperty(
        "--mvInterval",
        `${exInteval / 1000}s`
      );
      this.LoopTimer.push(setTimeout(turnLoop.bind(this), exInteval));
    } else {
      this.LoopTimer.push(setTimeout(turnLoop.bind(this), interval));
    }
  }

  setSwitch() {
    const btn = [...document.querySelectorAll(".js-gltypechangebtn")];

    btn.forEach((el) => {
      el.addEventListener("click", () => {
        //console.log(el.getAttribute("data-type"), this.backFace.state);
        if (
          (el.getAttribute("data-type") === "2d" && !this.backFace.state) ||
          (el.getAttribute("data-type") === "3d" && this.backFace.state)
        ) {
          return;
        }
        this.clearTimers();
        this.activateTurn(0.1, 0.8); //手動時はちょっと早く
        this.setLoop("btnChange");
      });
    });
  }

  watchScroll() {
    // 監視する対象（data-orderの値順にtargetObjectsに入れています）
    const targetObjects = [...document.querySelectorAll(".mv")];

    // IntersectionObserverの設定
    const options = {
      threshold: 0,
    };

    // コールバックの受け取り
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          //console.log(`MV : 交差開始`);
          this.runRaf = true;
          this.run();

          if (this.LoopTimer.length === 0 && this.glReady) {
            //console.log("raf start setLoop");
            this.setLoop("reset");
          }
        } else {
          //console.log(`MV : 交差終了`);
          this.runRaf = false;
          this.clearTimers();
        }
      });
    };

    // IntersectionObserverオブジェクトを作る
    const observerObject = new IntersectionObserver(callback, options);

    // 監視対象の監視を開始する
    targetObjects.forEach((object) => {
      observerObject.observe(object);
    });
  }

  run() {
    const clock = new THREE.Clock();
    clock.start();

    const raf = () => {
      const elapsed = clock.getElapsedTime();

      this.stage.onRaf();
      this.lights.onRaf(elapsed);

      this.meshList.forEach((mesh) => {
        mesh.onRaf(elapsed);
      });

      if (this.runRaf) {
        requestAnimationFrame(raf);
      }
    };

    raf();
  }

  destroy() {
    //console.log("WebGL Destroy");

    this.rafEnd = true;
    this.meshList.forEach((el) => el.destroy());
    this.stage = null;
  }
}
